import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import cc from "classcat"
import Highlighter from "react-highlight-words"
import useTranslations from "hooks/useTranslations"
import Divided from "components/organisms/common/Divided"

const GirlImage = ({ className }) => {
  const images = useStaticQuery(graphql`
    {
      girlImage: file(
        relativePath: { eq: "schools/AdobeStock_329694923.jpeg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 90, width: 600)
        }
      }
    }
  `)

  return (
    <GatsbyImage
      image={getImage(images.girlImage)}
      imgStyle={{
        objectFit: "cover",
        objectPosition: "top",
      }}
      className={className}
    />
  )
}

const Text = ({ className, children }) => (
  <p
    className={cc([
      "m-0 whitespace-pre-line text-left font-display text-2xl text-zinc-800 sm:text-2xl",
      className,
    ])}
  >
    {children}
  </p>
)

const SmallText = ({ className, children }) => (
  <p
    className={cc([
      "m-0 whitespace-pre-line text-left text-base text-zinc-700",
      className,
    ])}
  >
    {children}
  </p>
)

export default function InfoGirl() {
  const {
    schoolsInfo2Title,
    schoolsInfo2Text,
    schoolsInfo2Highlight,
    schoolsInfo2SmallText,
  } = useTranslations()

  return (
    <Divided Image={GirlImage} title={schoolsInfo2Title} theme="light" reversed>
      <div>
        <Text>
          <Highlighter
            highlightClassName="text-kkm-green bg-transparent"
            searchWords={schoolsInfo2Highlight || [""]}
            autoEscape
            textToHighlight={schoolsInfo2Text || ""}
          />
        </Text>
        <SmallText className="mt-8 lg:mt-16">{schoolsInfo2SmallText}</SmallText>
      </div>
    </Divided>
  )
}
